import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Home from './Home';
import Privacy from './Privacy';
import Terms from './Terms';
import Profile from './Profile';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </div>
  );
}

const styles = {
  pageContainer: { 
      position: "absolute",
      backgroundColor: "#C60000",
      height: "100%", 
      width: "100%",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "space-around"
  },
  welcomeMsg: {
      width: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
  },
  welcomeMsgText: {
      fontSize: 18,
      color: "white"
  },
  logo: {
      width: 30, 
      height: 40
  },
  appstore: {
      width: 150, 
      height: 50
  },
  title: {
      color: "white",
      marginLeft: 20
  }
};

export default App;
